export default {
  deselectKey: '鼠标右键，取消选择',
  bindWechatSuccess: '绑定微信成功',
  wechatLoginFail: '微信登录服务连接失败',
  changePasswordSuccess: '修改密码成功',
  loading: '请稍后，正在操作中',
  light: {
    maxLimit: '已达最大自定义模式数量，无法添加更多',
    noSelect: '请选择键盘上任意键',
  },
  device: {
    initializeFailed: '设备服务初始化失败',
    scanFailed: '设备扫描失败',
    disconnected: '设备已断开',
    disconnected2: '未检测到设备，请检查是否已断开，需重新连接',
    connectedFailed: '无法连接设备',
    connectedFailed2: '无法连接设备，请检查设备是否休眠或设备是否正确添加后重试',
    fail: '获取数据失败，请检查设备或稍后重试',
  },
  keys: {
    disableBeforeSwitch: '请先关闭按键的 {type} 功能后再将其修改为其他功能键',
    maxFnMappings: '最多只支持 4 个按键被改成 Fn',
    advancedSlotFull: '高级改键槽位已满，请先恢复其他按键后再试',
    advancedTypeFull: '{type} 的数量已达上限，请先删除已有的绑定后再新建',
    advancedDeleted: '已删除该高级按键绑定',
    mtApply: '需要点击“生效”才可以完成 MT 功能改键',
    mtSelect: '请先选择虚拟键盘上的任意按键，才可继续生效该按键的 MT 改键功能',
    advancedSelectKey: '请先在上方虚拟键盘选择要绑定的按键',
    comingSoon: '该功能正在开发中',
    dksApply: '需要点击“生效”才可以完成 DKS 功能改键',
    dksSelectKeyFirst: '请先选择按键',
    dksSelect: '请先选择虚拟键盘上的任意按键，才可继续生效该按键的 DKS 改键功能',
    tglApply: '需要点击“生效”才可以完成 TGL 功能改键',
    tglSelect: '请先选择虚拟键盘上的任意按键，才可继续生效该按键的 TGL 改键功能',
    rsApply: '需要点击“生效”才可以完成 RS 功能改键',
    rsSelect: '请先在上方虚拟键盘选择两个按键，才可继续生效 RS 改键功能',
    rsSameKey: 'RS 需要绑定两个不同的按键',
    socdApply: '需要点击“生效”才可以完成 SOCD 功能改键',
    socdSelect: '请先在上方虚拟键盘选择两个按键，才可继续生效 SOCD 改键功能',
    socdSameKey: 'SOCD 需要绑定两个不同的按键',
    fnNotSupported: 'Fn键不支持修改',
    keyNotSupported: '按键不支持修改',
    factoryLocked: '出厂配置中的功能键不能被修改',
    macroMax128: '最多支持 128 个宏',
    macroMax: '最多支持 {count} 个宏',
    macroSaved: '宏已保存',
    macroBindSelectKey: '请在虚拟键盘中，选择任意按键进行宏定义绑定',
    macroBindSelectMacro: '可选择任意宏文件进行绑定设置改键',
    macroJsonOnly: '只支持 .json 文件格式',
    macroMissingTopLevel: '文件格式错误：缺少 Macro 或 Platform 字段',
    macroMissingFields: '文件格式错误：Macro 缺少字段 {fields}',
    macroDuplicateId: '导入失败：ID {id} 已存在',
    macroImportSuccess: '宏文件导入成功',
    macroParseFailed: '文件解析失败，请检查文件内容',
    macroRenameEmpty: '名称不能为空',
    macroRenameTruncated: '名称最多 16 字节，已自动截断',
    macroEmptyUnsupported: '不支持设置空白宏',
    macroRecordingLimit: '宏录制已达最大长度',
    macroRecordingLimit2: '宏内容已超过最大长度',
    atLeastOne: '请至少选择一个按键',
    atLeastOneLeftClick: '至少保留一个左键',
    wheelOnly: '仅鼠标滚轮支持滚轮相关的改键',
    wheelRestricted: '滚轮按键不支持设置火力键、狙击键、DPI相关、配置切换、接收器切换功能',
    wheelRestricted2: '滚轮按键不支持设置宏功能',
    exportSuccess: '宏文件导出成功',
  },
  firmware: {
    upgrading: '固件升级中，请勿重复操作',
    upgradeFailed: '固件升级失败，请重试',
    downloadFailed: '固件压缩包下载失败',
    hexNotFound: '压缩包中未找到 .hex 格式的固件文件',
    upgradeListFailed: '未查询到更新日志',
  },
  factoryReset: {
    success: '恢复出厂设置成功',
  },
  cloud: {
    uploadFail: '上传失败',
    uploadSuccess: '上传成功',
    loginExpiredUpload: '登录状态已失效，请登录后重新上传',
    downloadFail: '下载失败',
    downloadSuccess: '下载成功',
    operating: '正在操作中，请稍后',
    selectConfig: '请选择配置文件',
    deleteFail: '删除失败',
    deleteSuccess: '删除成功',
  },
  configuration: {
    getListFail: '获取配置列表失败',
    getCurrentFail: '获取当前配置失败',
    notSupported: '当前设备不支持配置功能',
    createSuccess: '创建配置成功：{name}',
    createFail: '创建配置失败',
    maxLimitReached: '自定义配置数量已达上限',
    maxLimitName: '配置名称过长',
    defaultDeleteForbidden: '默认配置不可删除',
    currentInUseDeleteForbidden: '当前配置正在使用中，不可删除',
    deleteSuccess: '配置删除成功',
    deleteFail: '删除配置失败',
    defaultRenameForbidden: '默认配置不可重命名',
    renameSuccess: '重命名成功',
    renameFail: '重命名失败',
    switchSuccess: '切换配置成功',
    switchFail: '切换配置失败',
  },
  pages: {
    fileAccept: '只支持 {accepts} 图片类型',
  },
}
